<template>
  <div class="videos-wrapper">
    <md-swiper
        ref="swiper"
        :is-prevent="false"
        :is-loop="false"
        :default-index="current"
        :autoplay="0"
        :dragable="false"
        :has-dots="false"
        @after-change="afterChange"
    >
      <md-swiper-item data-type="hot">
        <short-video type="hot" data-type="hot" :currentType="type" :doubleKey="doubleKey"/>
      </md-swiper-item>

      <md-swiper-item data-type="home">
        <short-video type="home" data-type="home" :currentType="type"  :doubleKey="doubleKey"/>
      </md-swiper-item>

      <md-swiper-item data-type="authentication">
        <short-video type="authentication" data-type="authentication" :currentType="type"   :doubleKey="doubleKey"/>
      </md-swiper-item>
    </md-swiper>
  </div>
</template>

<script>
import ShortVideo from '@components/ShortVideo';
import { Swiper, SwiperItem } from 'mand-mobile';

export default {
  name: 'HomeShortVideo',
  components: {
    ShortVideo,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem
  },
  props: {
    current: {
      type: Number,
      default: () => 1
    },
    doubleKey: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    type () {
      switch (this.current) {
        case 0:
          return 'hot';
        case 1:
          return 'home';
        case 2:
          return 'authentication';
        default:
          return 'home';
      }
    }
  },
  watch: {
    current (val) {
      this.$refs.swiper.goto(val);
    }
  },
  methods: {
    afterChange (from, to) {
      this.$emit('changeIndex', to);
    }
  }
};
</script>

<style lang="scss" scoped>
.videos-wrapper {
  height: 100%;
}
</style>
